module.exports = __webpack_public_path__ + "static/media/ColbyRaha 198x3 TopBikeImageOnly.6899229b.png";